import { atom } from 'infrastructure/state/jotai.wrapper'
import { INode } from 'shared/types/tree'
import {
  getMasterUpdateValidations,
  getTreeCurriculaMap,
} from '../../masters_management/utility'
import { atomWithRefresh } from 'infrastructure/state/atomWithRefresh'
import { mastersByIdWithErrorAtom } from '../../../api/masters.atoms'
import { byStringFieldSort } from '../../Helpers'
import { useAtomWithErrorNotification } from 'shared/ui/GlobalDialog'

export const masterTreeIdAtom = atom('')
export const validationsTreeAtom = atom<INode | undefined>(undefined)
export const curriculaMapAtom = atomWithRefresh(async (get) => {
  const masterTreeId = get(masterTreeIdAtom)
  if (!masterTreeId) return
  return getTreeCurriculaMap(masterTreeId)
})

export const updateValidationsAtom = atom((get) => {
  const tree = get(validationsTreeAtom)
  if (!tree) return
  return getMasterUpdateValidations(tree)
})

const sortedMastersAtom = atom((get) => {
  const { result: mastersById, error } = get(mastersByIdWithErrorAtom)
  const masterTreeId = get(masterTreeIdAtom)
  if (!mastersById || !(masterTreeId in mastersById)) {
    return {
      result: [],
      error,
    }
  }
  const masters = mastersById[masterTreeId]
  return {
    result: masters.sort(byStringFieldSort('createdAt')).reverse(),
    error,
  }
})

export function useSortedMastersWithErrorNotification() {
  return useAtomWithErrorNotification(
    { errorTitle: 'Error Retrieving Masters' },
    sortedMastersAtom,
  )
}
